import { Dispatch, SetStateAction } from 'react'

export enum GrantDetailsHeaderKey {
  OVERVIEW = 'overview',
  ORGANISATION = 'organisation',
  NOMINATIONS = 'nominations',
  DOCUMENTS = 'documents',
  DONATION = 'donation'
}

export type GrantDetailsHeaderTabs = Array<{
  label: string
  key: GrantDetailsHeaderKey
}>

export type GrantDetailsHeaderProps = {
  programName: string
  activeTab: GrantDetailsHeaderKey
  setActiveTab: (tab: GrantDetailsHeaderKey) => void
  tasksOpen: boolean
  setTasksOpen: Dispatch<SetStateAction<boolean>>
  hasTasks: boolean
  hasNominations: boolean
  hasAward: boolean
}
